import { FC, useCallback } from 'react';
import graphql from 'babel-plugin-relay/macro';

import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import TableRow from '@mui/material/TableRow';
import Table from 'components/Table';
import TableCell from 'components/TableCell';
import HotelImportsTableRow from 'components/HotelImportsTableRow';

import { usePagination } from 'components/Pagination';
import { useAvoidSuspense, useSkipFirstLoad } from 'lib';

import Query, {
  HotelImportsTableRefetchQuery,
} from '__generated__/HotelImportsTableRefetchQuery.graphql';
import { HotelImportsTable_data$key } from '__generated__/HotelImportsTable_data.graphql';

type Props = {
  data: HotelImportsTable_data$key;
};

const HotelImportsTable: FC<Props> = props => {
  const { variables } = usePagination();

  const [data, { refetch, loading }] = useAvoidSuspense<
    HotelImportsTableRefetchQuery,
    HotelImportsTable_data$key
  >(
    graphql`
      fragment HotelImportsTable_data on Query
      @refetchable(queryName: "HotelImportsTableRefetchQuery") {
        hotelImports(first: $first, after: $after) {
          edges {
            node {
              id
              ...HotelImportsTableRow_import
            }
          }

          pageInfo {
            ...Table_pageInfo
          }
        }
      }
    `,
    props.data,
    Query
  );

  useSkipFirstLoad(
    useCallback(() => {
      refetch({
        ...variables,
      });
    }, [refetch, variables])
  );

  const { edges, pageInfo } = data.hotelImports ?? {};

  return (
    <Table
      pagination
      pageInfo={pageInfo ?? null}
      loading={loading}
      icon={<CloudDownloadIcon />}
      head={
        <TableRow>
          <TableCell>Pradėta</TableCell>
          <TableCell center>Būklė</TableCell>
          <TableCell center>Viso viešbučių</TableCell>
          <TableCell center>Apdorota</TableCell>
          <TableCell center>Importuota</TableCell>
          <TableCell center>Atnaujinta</TableCell>
        </TableRow>
      }>
      {edges?.map(({ node }) => (
        <HotelImportsTableRow key={node.id} import={node} />
      ))}
    </Table>
  );
};

export default HotelImportsTable;
